import { render, staticRenderFns } from "./DefectsHistory.vue?vue&type=template&id=36aacb57&scoped=true&"
import script from "./DefectsHistory.vue?vue&type=script&lang=js&"
export * from "./DefectsHistory.vue?vue&type=script&lang=js&"
import style0 from "./DefectsHistory.vue?vue&type=style&index=0&id=36aacb57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aacb57",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VTextField})
